//@flow

export function reinsert(arr: Array<*>, from: number, to: number): Array<*> {
  const _arr = arr.slice(0)
  const val = _arr[from]
  _arr.splice(from, 1)
  _arr.splice(to, 0, val)
  return _arr
}

export function clamp(n: number, min: number, max: number): number {
  return Math.max(Math.min(n, max), min)
}

export function layout(
  idx: number,
  itemWidth: number,
  itemHeight: number,
  cols: number,
  gutter: number
): Array<number> {
  const row = Math.floor(idx / cols)
  const col = idx % cols
  return [
    col * (itemWidth + (col > 0 ? gutter : 0)),
    row * itemHeight + (row > 0 ? gutter : 0)
  ]
}



// WEBPACK FOOTER //
// ./src/UI/GridView/helpers.js